import React from "react";

import { CardHeader, CardSection } from "Common/Card";

import Chrome from "./Chrome";

const LoadingPage = () => (
  <Chrome title="Loading...">
    <CardHeader>Loading information...</CardHeader>
    <CardSection>This will only take a moment.</CardSection>
  </Chrome>
);

export default LoadingPage;
